import { render, staticRenderFns } from "./workordermanagementlist.vue?vue&type=template&id=0c4688f6"
import script from "./workordermanagementlist.vue?vue&type=script&lang=js"
export * from "./workordermanagementlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports